import sendRequest from '../ppdNetwork/index.js';
const SPANIDS = ['clk', 'pv', 'ready', 'request', 'stage', 'leave'];
function Metrics(eventName, content = {}) {
    // 通用参数赋值
    this.initProperty();
    if (PPDWebUI && PPDWebUI.MetricsService && PPDWebUI.MetricsService.report) {
        this.initPPDWebUISendData(eventName);
    } else {
        this.initSendData(eventName);
    }
    this.updateContent(content);
    this.addListener();
}

Metrics.prototype.initProperty = function() {
    Object.defineProperty(this, 'appInfos', {
        value:
            typeof PPDWebUI === 'object' &&
            PPDWebUI !== null &&
            PPDWebUI.appInfos
                ? PPDWebUI.appInfos
                : {},
        writable: false
    });
};
Metrics.prototype.initPPDWebUISendData = function(eventName) {
    this.sendData = { trace: {} };
    this.sendData.trace.traceId = getTraceId();
    this.sendData.eventName = eventName;
    this.sendData.content = {};
};
Metrics.prototype.initSendData = function(eventName) {
    this.sendData = { trace: {} };
    this.sendData.trace.traceId = getTraceId();
    this.sendData.eventName = eventName;
    this.sendData.openId = getCookie('openid') || this.appInfos.openid;
    this.sendData.contentType = 'normal';
    this.sendData.appInfo = getAppInfos(this.appInfos);
    this.sendData.systemInfo = getSystemInfo(this.appInfos);
    this.sendData.trace.sessionId = this.appInfos.sessionId;
    this.sendData.content = {};
};
Metrics.prototype.point = function(spanId, content = {}) {
    // 发送埋点，此时不会修改content通用参数
    // debugger;
    let sendData = JSON.parse(JSON.stringify(this.sendData));
    sendData.content = Object.assign({}, sendData.content, content);
    sendData.startFlag = content.startFlag || 0;
    let data = Object.assign({}, sendData, dynamicProperty());
    data.trace.spanId = spanId;
    if (PPDWebUI && PPDWebUI.MetricsService && PPDWebUI.MetricsService.report) {
        PPDWebUI.MetricsService.report(data);
    } else {
        sendRequest({
            showNetToast: false, // 网络异常toast
            showBusinessToast: false, // 业务异常toast
            showLoading: false, // loading
            method: 'post',
            url: 'metricshome/metrics/report',
            params: {
                data: [data],
                type: 1
            }
        });
    }
};

Metrics.prototype.updateContent = function(content = {}) {
    // 设置content通用参数
    if (content.router) {
        this.updateRouter(content.router);
        delete content.router;
    }
    this.sendData.content = Object.assign(
        {},
        this.sendData.content || {},
        content
    );
};

Metrics.prototype.updateRouter = function(router) {
    if (!router) return;
    let self = this;
    router.beforeResolve(function(to, from, next) {
        delete self.sendData.content;
        next();
    });
};
SPANIDS.map(function(spanId) {
    Metrics.prototype[spanId] = function(content) {
        return this.point(spanId, content);
    };
});

Metrics.prototype.addListener = function() {
    document.addEventListener(
        'click',
        e => {
            if (e.target.attributes.hasOwnProperty('ppd-metrics')) {
                this.point('clk', {
                    text: e.target.innerText || e.target.innerHTML
                });
            }
        },
        true
    );
};

function uuid() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
}
function getCookie(key) {
    let res = document.cookie.match(eval(`/${key}=([^\\;]*)/`));
    return res && res[1];
}
function dynamicProperty() {
    let timestamp = new Date().getTime();
    let eventId = uuid();
    return { timestamp, eventId };
}
function getAppInfos({ appId, BuildType, pid, version }) {
    return {
        appId,
        buildType: BuildType,
        identifier: window.location.hostname,
        pid,
        version
    };
}
function getTraceId() {
    let res = sessionStorage.getItem('metrics-traceid');
    if (!res) {
        res = uuid();
        sessionStorage.setItem('metrics-traceid', res);
    }
    return res;
}
function getSystemInfo({
    DUID,
    manufacturer,
    model,
    osNum,
    osVersion,
    platform
}) {
    return {
        duid: DUID,
        manufacturer,
        model,
        osNum,
        osVersion,
        platform
    };
}

export default Metrics;
